import { Moon, Sun } from 'lucide-react';

import { useDarkMode } from '../hooks/useDarkMode';

/** Bascule clair/sombre — même place et même allure que dans le registre. */
export function DarkModeToggle() {
  const { sombre, basculer } = useDarkMode();
  const libelle = sombre ? 'Activer le mode clair' : 'Activer le mode sombre';

  return (
    <button
      type="button"
      onClick={basculer}
      title={libelle}
      aria-label={libelle}
      aria-pressed={sombre}
      className="p-1.5 rounded-lg text-slate-400 hover:text-slate-600 dark:text-slate-400 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
    >
      {sombre ? (
        <Moon className="h-4 w-4" aria-hidden="true" />
      ) : (
        <Sun className="h-4 w-4" aria-hidden="true" />
      )}
    </button>
  );
}
